import Margin from "~/components/Margin";
import {
  Outlet,
  //  useLocation,
  useNavigate,
} from "react-router-dom";
import {
  FunctionComponent,
  useCallback,
  useMemo,
  useState,
  // useEffect,
} from "react";
import WhiteLeft from "~/assets/white-left.png";

import { Breadcrumb, Button, Input, Modal } from "prosperita-dumbo-react";
import activityIcon from "~/assets/Activity.png";
import lockIcon from "~/assets/lock.png";
import styled from "styled-components";
import NewDebitor from "./NewDebitor";
import useOperation from "~/hooks/useOperation";
import NewInvolved from "./NewInvolved";
import Stepper from "~/components/Stepper";
import NewDocument from "./NewDocument";
import {
  getSimulateOperationAPI,
  IOperationInvolved,
  IOperationInvolvedDocumentsBody,
  postConfirmationOperationAPI,
  postOperationAPI,
  postOperationInvolvedDocumentsAPI,
  postOperationInvolvedsAPI,
  postSimulateOperationAPI,
} from "~/services/api/operations";
import useLoading from "~/hooks/useLoading";
import { toast } from "react-toastify";
import { getErrorMessage } from "~/services/api/error";
import ArrowIcon from "~/assets/arrow-right-_1_.png";
import AppStorage from "~/services/storage";
import { onlyNumbers } from "~/services/utils";

const Container = styled.div`
  display: flex;
  flex-direction: column;
  width: 100%;
  height: auto;
  overflow: hidden;
  align-items: start;
  padding: 30px 50px;
  box-sizing: border-box;
`;

const Title = styled.h2`
  color: #000;
  font-size: 30px;
  font-style: normal;
  font-weight: 100;
  line-height: 40px;
`;

const TagLup = styled.img`
  object-fit: contain;
  width: 200px;
  margin: 20px 0;
`;

const Text = styled.h4`
  color: #161616;
  font-family: "IBM Plex Sans";
  font-size: 21px;
  font-style: normal;
  font-weight: 400;
  line-height: 28px;
  margin-top: 20px;
`;

const Subtext = styled.h4`
  color: #161616;
  font-size: 16px;
  font-style: normal;
  font-weight: 400;
  line-height: 22px;
  margin-top: 20px;
`;

const canViewOperations = true;

const NewOperations: FunctionComponent = () => {
  const navigate = useNavigate();
  const { setLoading } = useLoading();
  const {
    tab,
    setRecoverSimulation,
    recoverSimulation,
    canAdvance,
    setTab,
    setSimulateResult,
  } = useOperation();
  // const locationURL = useLocation();
  const steps = [
    {
      label: "Operação",
      isCompleted: tab > 0,
      isActive: tab === 0,
    },
    {
      label: "Informações do produto",
      isCompleted: tab > 1,
      isActive: tab === 1,
    },
    { label: "Envolvidos", isCompleted: tab > 2, isActive: tab === 2 },
    { label: "Documentos", isCompleted: tab > 3, isActive: tab === 3 },
  ];

  const handleClose = () => {
    setRecoverSimulation(false);
    setUuid("");
  };

  const isNotCommercialNoteRecover = useCallback(() => {
    toast.error(
      "Este ID é inválido ou não pertence a uma simulação de Nota Comercial."
    );
    setRecoverSimulation(false);
    setLoading(false);
    localStorage.removeItem("@:simulation_uuid");
  }, [setLoading, setRecoverSimulation]);

  const [uuid, setUuid] = useState<string>("");

  const fetchSimulation = async () => {
    setLoading(true);

    try {
      const { data } = await getSimulateOperationAPI(uuid);

      if (data.payload.product.product_type !== "commercial_note") {
        return isNotCommercialNoteRecover();
      }

      const simulation = data.payload;

      localStorage.setItem(
        "@:simulation_uuid",
        JSON.stringify({ simulation_uuid: data.payload.uuid })
      );

      const payload = {
        nickname: simulation.nickname,
        product_uuid: simulation.product.uuid,
        calculation_type: simulation.calculation_type,
        requested_amount: String(simulation.requested_amount),
        unit_amount: String(simulation.unit_amount),
        duration: simulation.duration,
        calculation_base: simulation.calculation_base,
        release_date: simulation.release_date,
        due_date: simulation.due_date,
        taxes_settings: {
          interest_rate_monthly:
            simulation.taxes_settings.interest_rate_monthly,
          interest_periodicity: simulation.taxes_settings.interest_periodicity,
          amortization_grace_period:
            simulation.taxes_settings.amortization_grace_period,
          interest_grace_period:
            simulation.taxes_settings.interest_grace_period,
          commission: simulation.taxes_settings.commission,
          indexer: simulation.taxes_settings.indexer,
          indexer_rate: simulation.taxes_settings.indexer_rate,
        },
      };

      localStorage.setItem("@:simulate_operation", JSON.stringify(payload));

      location.reload();

      setRecoverSimulation(false);

      // setTimeout(() => {
      //   toast.success("Simulação recuperada com sucesso !");
      // }, 3000);

      setLoading(false);
    } catch (e) {
      console.log(e);
      toast.error(getErrorMessage(e, "Não foi possível recuperar a simulação !"));
      setLoading(false);
    }
  };
  const notifySuccess = () => {
    toast.success("Operação criada com sucesso!");
  };

  const notifyError = () => {
    toast.error("Não foi possível criar a operação!");
  };

  const sendNewOperation = useCallback(async (): Promise<void> => {
    setLoading(true);
    try {
      const recoveredSimulationUuid = AppStorage.get(
        "@:simulation_uuid"
      ) as string;
      const simulationUuid = recoveredSimulationUuid
        ? JSON.parse(recoveredSimulationUuid).simulation_uuid
        : "";
      let operationUuid = simulationUuid;

      const payloadSimulateOperation = AppStorage.get(
        "@:simulate_operation"
      ) as string;
      const payloadSimulateOperationParsed = payloadSimulateOperation
        ? JSON.parse(payloadSimulateOperation)
        : null;

      if (payloadSimulateOperationParsed.birthday_date_type === "") {
        delete payloadSimulateOperationParsed.birthday_date_type;
        delete payloadSimulateOperationParsed.birthday_date_day;
      }

      if (payloadSimulateOperationParsed.birthday_date_type === "payment") {
        delete payloadSimulateOperationParsed.birthday_date_day;
      }

      if (payloadSimulateOperationParsed?.birthday_date_type === "fixed") {
        payloadSimulateOperationParsed.birthday_date_day = Number(
          payloadSimulateOperationParsed.birthday_date_day
        );
      }

      const payloadOperation = AppStorage.get("@:operation") as string;
      const payloadOperationParsed = payloadOperation
        ? JSON.parse(payloadOperation)
        : {};

      if (!simulationUuid) {
        const { data } = await postSimulateOperationAPI(
          payloadSimulateOperationParsed
        );
        operationUuid = data.payload.uuid;
      }

      payloadOperationParsed.operation_uuid = operationUuid;

      const payloadAsset = {
        ...payloadOperationParsed,
      };

      // Salva o tipo original para verificação antes de converter
      const originalLiquidationType = payloadAsset.liquidation_type;

      // Converte pix_key e pix_bank_account para "pix" no payload final (sempre "pix")
      if (payloadAsset.liquidation_type === "pix_key" || payloadAsset.liquidation_type === "pix_bank_account") {
        payloadAsset.liquidation_type = "pix";
      }

      if (payloadAsset.liquidation_type !== "billet") {
        delete payloadAsset.invoice_barcode;
      }

      // Se for PIX com chave, deleta conta bancária e processa a chave
      if (originalLiquidationType === "pix_key") {
        delete payloadAsset.liquidation_bank_account_uuid;

        if (String(payloadAsset.pix_key_type).includes("document_number")) {
          payloadAsset.pix_key_type = "document_number";
          payloadAsset.pix_key = onlyNumbers(payloadAsset.pix_key);
        }
      }

      // Se for PIX com conta bancária, define pix_key_type como "bank_account"
      if (originalLiquidationType === "pix_bank_account") {
        payloadAsset.pix_key_type = "bank_account";
        delete payloadAsset.pix_key;
      }

      // Se não for PIX de nenhum tipo, deleta campos de PIX
      if (payloadAsset.liquidation_type !== "pix") {
        delete payloadAsset.pix_key_type;
        delete payloadAsset.pix_key;
      }

      const { data: dataOperation } = await postOperationAPI(payloadAsset);

      const assetUuid = dataOperation.payload.uuid;

      const involveds = AppStorage.get("@:involveds") as string;
      const involvedsParsed = involveds ? JSON.parse(involveds) : [];
      if (involvedsParsed && Array.isArray(involvedsParsed)) {
        const involvedPromises = involvedsParsed.map(
          async (involved: IOperationInvolved) => {
            const {
              auth_type,
              involved_partner_uuid,
              is_signer,
              relationship,
              send_type,
              sign_weight,
              related_to_uuid,
            } = involved;

            return await postOperationInvolvedsAPI({
              asset_uuid: dataOperation.payload.uuid,
              auth_type,
              involved_partner_uuid,
              is_signer: String(is_signer) === "false" ? false : true,
              relationship,
              send_type,
              sign_weight: sign_weight === "" ? 0 : Number(sign_weight),
              related_to_uuid,
            });
          }
        );
        await Promise.all(involvedPromises);
      }

      const documents = AppStorage.get("@:documents") as string;
      const documentsParsed = documents ? JSON.parse(documents) : [];
      if (documentsParsed && Array.isArray(documentsParsed)) {
        const documentsPromises = documentsParsed.map(
          async (document: IOperationInvolvedDocumentsBody) => {
            const { type, file, related_to_uuid } = document;

            const formData = new FormData();

            if (typeof file === "string") {
              const byteCharacters = atob(file.split(",")[1]);
              const byteArray = new Uint8Array(byteCharacters.length);

              for (let i = 0; i < byteCharacters.length; i++) {
                byteArray[i] = byteCharacters.charCodeAt(i);
              }
              const blob = new Blob([byteArray], {
                type: "application/octet-stream",
              });
              formData.append("file", blob, "filename.ext");
            } else {
              formData.append("file", file);
            }

            formData.append("type", type);
            formData.append("description", type);
            formData.append("related_to_uuid", related_to_uuid);
            formData.append("asset_uuid", assetUuid);

            return await postOperationInvolvedDocumentsAPI(formData);
          }
        );
        await Promise.all(documentsPromises);
      }

      await postConfirmationOperationAPI(assetUuid);

      navigate(`/app/credit/operations/details/${assetUuid}`);
      notifySuccess();

      localStorage.removeItem("@:simulation_uuid");
      setLoading(false);
    } catch (e) {
      setLoading(false);
      notifyError();
      console.error(e);
    }
  }, [navigate, setLoading]);

  const advanceFunctionsDict = useMemo(() => {
    return {
      "operations/new/commercial-note/operation": () => {
        navigate("/app/credit/operations/new/commercial-note/product-info");
        setTab(1);
      },
      "operations/new/commercial-note/product-info": () => {
        // Validar antes de avançar
        const validateProductInfo = (window as any).validateProductInfo;
        if (validateProductInfo && typeof validateProductInfo === "function") {
          const isValid = validateProductInfo();
          if (!isValid) {
            return; // Não avança se houver erros
          }
        }
        navigate("/app/credit/operations/new/commercial-note/involveds");
        setTab(2);
      },
      "operations/new/commercial-note/involveds": () => {
        navigate("/app/credit/operations/new/commercial-note/documents");
        setTab(3);
      },
      "operations/new/commercial-note/documents": () => {
        sendNewOperation();
      },
    };
  }, [navigate, setTab, sendNewOperation]);

  const returnFunctionsDict = useMemo(() => {
    return {
      "/app/credit/operations/new/commercial-note/product-info": () => {
        navigate("/app/credit/operations/new/commercial-note/operation");
        setTab(0);
      },
      "/app/credit/operations/new/commercial-note/involveds": () => {
        navigate("/app/credit/operations/new/commercial-note/product-info");
        setTab(1);
      },
      "/app/credit/operations/new/commercial-note/documents": () => {
        navigate("/app/credit/operations/new/commercial-note/involveds");
        setTab(2);
      },
    };
  }, [navigate, setTab]);

  const returnFunctions = useCallback(() => {
    const path = location.pathname;
    
    // Verificar na ordem inversa (mais específico primeiro) para evitar conflitos
    if (path.includes("/app/credit/operations/new/commercial-note/documents")) {
      returnFunctionsDict["/app/credit/operations/new/commercial-note/documents"]();
    } else if (path.includes("/app/credit/operations/new/commercial-note/involveds")) {
      returnFunctionsDict["/app/credit/operations/new/commercial-note/involveds"]();
    } else if (path.includes("/app/credit/operations/new/commercial-note/product-info")) {
      returnFunctionsDict["/app/credit/operations/new/commercial-note/product-info"]();
    }
  }, [returnFunctionsDict]);

  const advance = useCallback(() => {
    const path = location.pathname;
    Object.keys(advanceFunctionsDict).forEach((rota) => {
      if (path.includes(rota)) {
        advanceFunctionsDict[rota]();
      }
    });
  }, [advanceFunctionsDict]);

  return (
    <Container>
      <div
        style={{
          position: "fixed",
          top: 110,
          right: "0",
          background: "#fff",
          width: "100%",
          zIndex: 4,
          paddingLeft: "47px",
          paddingRight: "47px",
          paddingBottom: "20px",
          paddingTop: "20px",
        }}
      >
        <div
          style={{
            display: "flex",
            justifyContent: "start",
          }}
        >
          <Breadcrumb
            crumbsOptions={[
              {
                crumb: "Operações",
                onClick: () => navigate("/app/credit/operations"),
              },
              {
                crumb: "Nova operação (Nota Comercial)",
              },
            ]}
            endHiddenIndex={5}
            startHiddenIndex={5}
          />
        </div>
        <div
          style={{
            display: "flex",
            justifyContent: "space-between",
            marginTop: "30px ",
          }}
        >
          <Title>Nova operação - Nota Comercial</Title>
          <div style={{ display: "flex", gap: "10px" }}>
            <div>
              <Button
                kind="ghost"
                size="large"
                label="Cancelar"
                onClick={() => {
                  setTab(0);
                  localStorage.removeItem("@:involveds");
                  localStorage.removeItem("@:simulate_operation");
                  localStorage.removeItem("@:operation");
                  localStorage.removeItem("@:documents");
                  navigate("/app/credit/operations/");
                  setSimulateResult(null);
                }}
              />
            </div>
            {!location.pathname.includes("operations/new/ccb/operation") && 
             !location.pathname.includes("/app/credit/operations/new/commercial-note/operation") && (
              <div>
                <Button
                  kind="secondary"
                  size="large"
                  icon={WhiteLeft}
                  label="Voltar"
                  onClick={() => {
                    returnFunctions();
                  }}
                />
              </div>
            )}
            {/* <div style={{ width: "250px" }}>
                      <Button
                        kind="secondary"
                        size="large"
                        label="Nova Simulação"
                        icon={activityIcon}
                        onClick={() => navigate("/app/credit/new-simulate/ccb")}
                      />
                    </div> */}
            <div style={{ width: "250px" }}>
              <Button
                kind="primary"
                size="large"
                disabled={
                  location.pathname.includes("/app/credit/operations/new/commercial-note/product-info")
                    ? false
                    : !canAdvance
                }
                label={
                  location.pathname.includes(
                    "/app/credit/operations/new/commercial-note/documents/"
                  )
                    ? "Finalizar"
                    : "Avançar"
                }
                icon={
                  location.pathname.includes(
                    "/app/credit/operations/new/commercial-note/documents/"
                  )
                    ? activityIcon
                    : ArrowIcon
                }
                onClick={() => advance()}
              />
            </div>

            {/* <div style={{ width: "250px" }}>
                            <Button
                              kind="primary"
                              disabled={
                                locationURL.pathname.includes("new/ccb/operation")
                                  ? false
                                  : true
                              }
                              size="large"
                              label="Recuperar simulação"
                              onClick={() => setRecoverSimulation(true)}
                            />
                          </div> */}
            {/* <div style={{ width: "250px" }}>
                            <Button
                              kind="secondary"
                              size="large"
                              label="Recuperar simulação"
                            />
                          </div> */}
          </div>
        </div>
        <Stepper steps={steps} />
      </div>
      <div style={{ width: "100%" }}>
        <>
          {canViewOperations && (
            <div>
              <div
                style={{
                  display: "flex",
                  justifyContent: "space-between",
                  marginTop: "30px ",
                }}
              >
                <Title>Nova operação - Nota Comercial</Title>
                <div style={{ display: "flex", gap: "10px" }}>
                  <div>
                    <Button
                      kind="ghost"
                      size="large"
                      label="Cancelar"
                      onClick={() => {
                        setTab(0);
                        localStorage.removeItem("@:involveds");
                        localStorage.removeItem("@:simulate_operation");
                        localStorage.removeItem("@:operation");
                        localStorage.removeItem("@:documents");
                        navigate("/app/credit/operations/");
                        setSimulateResult(null);
                      }}
                    />
                  </div>
                  {!location.pathname.includes(
                    "/app/credit/operations/new/commercial-note/operation"
                  ) && (
                    <div>
                      <Button
                        kind="secondary"
                        size="large"
                        icon={WhiteLeft}
                        label="Voltar"
                        onClick={() => {
                          returnFunctions();
                        }}
                      />
                    </div>
                  )}

                  <div style={{ width: "250px" }}>
                    <Button
                      kind="primary"
                      size="large"
                      disabled={!canAdvance}
                      label={
                        location.pathname.includes(
                          "/app/credit/operations/new/ccb/documents/"
                        )
                          ? "Finalizar"
                          : "Avançar"
                      }
                      icon={
                        location.pathname.includes(
                          "/app/credit/operations/new/ccb/documents/"
                        )
                          ? activityIcon
                          : ArrowIcon
                      }
                      onClick={() => advance()}
                    />
                  </div>
                  {/* <div style={{ width: "250px" }}>
                    <Button
                      kind="secondary"
                      size="large"
                      label="Recuperar simulação"
                    />
                  </div> */}
                </div>
              </div>
              <Stepper steps={steps} />
              <Margin mt={50} />
              <Outlet />
            </div>
          )}
        </>

        {!canViewOperations && (
          <>
            <div>
              <Margin mt={70} />
              <TagLup src={lockIcon} />
              <Margin mt={30} />
              <Text>Acesso restrito</Text>

              <Subtext>
                Você não tem permissão para criar operações de crédito, <br />{" "}
                contate o administrador do sistema para mais informações.
              </Subtext>
            </div>
          </>
        )}
      </div>

      <NewDebitor />
      <div style={{ zIndex: 9999 }}>
        <NewInvolved />
      </div>

      <div style={{ zIndex: 9999 }}>
        <NewDocument />
      </div>
      <div style={{ zIndex: 999 }}>
        <Modal
          radius
          height={"368px"}
          width="760px"
          background="#f4f4f4"
          open={recoverSimulation}
          onClose={() => handleClose()}
          label={<h4>Recuperar simulação</h4>}
          buttons={[
            {
              kind: "secondary",
              label: "Cancelar",
              onClick: () => handleClose(),
            },
            {
              kind: "primary",
              label: "Recuperar simulação",
              onClick: () => fetchSimulation(),
            },
          ]}
        >
          <div style={{ padding: "20px" }}>
            <Input
              label="Insira um ID para recuperar a simulação"
              size="large"
              type="text"
              placeholder="ID*"
              value={uuid}
              onChange={(e) => setUuid(e.target.value)}
            />
          </div>
        </Modal>
      </div>
    </Container>
  );
};

export default NewOperations;
